import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {ClientContactServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormFramework from './InnerFormFramework';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import {USER_DATA} from 'commons/constants';

FrameworkForm.propTypes = {
    title: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    enrollment: PropTypes.any,
    foreign: PropTypes.bool.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof FrameworkForm.propTypes>,
    ClientContactServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            personTypeKey: '',
            foreign: '',
            clientNumber: '',
            email: '',
            phoneNumber: '',
        };
    },
    mapPropsToValues: (props) => {
        const {enrollment} = props;
        let phoneNumber = '';
        let username = '';
        let email = '';
        if (enrollment) {
            phoneNumber = enrollment.phoneNumber || '';
            username = enrollment.personKey || '';
            email = enrollment.email || '';
        }
        return {
            expedientId: 0,
            workflowId: 0,
            viewId: 0,
            viewFatherId: 0,
            kycId: 0,
            personTypeKey: '',
            foreign: props.foreign,
            personKey: username,
            clientNumber: USER_DATA.username,
            email: email,
            phoneNumber: phoneNumber,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: ClientContactServiceRequest, props) => {
        const errors: FormikErrors<ClientContactServiceRequest> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormFramework);

function FrameworkForm(props: InferPropTypes<typeof FrameworkForm.propTypes>) {
    const {submitHandler, isLoading, fields, title, enrollment, foreign} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            title={title}
            fields={fields}
            submitHandler={submitHandler}
            isLoading={isLoading}
            enrollment={enrollment}
            foreign={foreign}
        />
    );
}

export default FrameworkForm;
